export default {
  title: "Register",
  toLoginMessage: "Log in",
  subscribe: "Subscribe to EXPOСENTRE notifications",
  consent1:
    "I hereby consent to the processing of my personal data on the following",
  consent2: "conditions for the processing of personal data",
  submit: "Submit",
  successMessage:
    "A link to confirm your account has been sent to specified e-mail",

  error: {
    userExists: "User with such e-mail already exists.",
    validation: "Validation error.",
    userCreation: "User creation error.",
    userElementCreation: "User element creation error.",
    server: "Server error"
  }
};
